import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { useParams } from 'react-router-dom';

import ProgressIndicator from '../../Common/ProgressIndicator';
import ErrorIndicator from '../../Common/ErrorIndicator';

import TaskEditForm from './TaskEditForm';

function TaskEditPage(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [task, setTask] = useState(null);
    const { taskId, eventId } = useParams();

    useEffect(() => {
        setIsLoading(true);
        Axios.get(`/admin/events/${eventId}/tasks/${taskId}`).then(res => {
            setTask(res);
            setIsLoading(false);
        }, err => {
            setIsLoading(false);
            setError(true);
        });
    }, [taskId, eventId]);

    if (isLoading)
        return <ProgressIndicator />;

    if (error)
        return <ErrorIndicator text="A rendezvény letöltése sikertelen." />;
    if (task)
        return (
            <>
                <h1>Feladat szerkesztése</h1>
                <TaskEditForm task={task} />
            </>
        );

    return null;
}

export default TaskEditPage;
